
import { MutationTree } from 'vuex';
import { GspModuleState } from './types';
import Vue from 'vue';
import gspModule, { GspModule, Value } from '@/shared/model/gspModule';
import { GSP_MODULE_CACHE_CONFIG as CACHE_CONFIG } from '@/shared/config/cache';

export const mutations: MutationTree<GspModuleState> = {
  setAllGspModules(state, modules: GspModule[]) {
    state.allGspModules = modules;
    // console.log('Setting cached state.allGspModules all GSP modules:', state.allGspModules);
    state.allGspModulesCache = {
      lastFetchTime: Date.now(),
      isValid: true,
    };
  },
  setAllGspModulesCache(state) {
    state.allGspModulesCache = {
      lastFetchTime: Date.now(),
      isValid: true,
    };
  },

  invalidateAllGspModulesCache(state) {
    state.allGspModulesCache = {
      lastFetchTime: null,
      isValid: false,
    };
  },


  setGspModules(state, payload: Value) {
    state.gspModules.items = payload.value.map((x) => gspModule.parse(x));
    state.gspModules.total = payload['@odata.count'] || 0;
    state.gspModules.isLoading = false;

    // Invalidate grouped cache when modules change
    if (CACHE_CONFIG.INVALIDATE_AFTER_MUTATIONS) {
      state.modulesGroupedCache.isValid = false;
    }
  },
  setGspModulesTotal(state, payload: number) {
    state.gspModules.total = payload;
  },
  setGspModulesIsLoading(state, payload: boolean) {
    state.gspModules.isLoading = payload;
  },





  /**
   * Update grouped modules cache
   * Called after grouping call
   */
  setModulesGroupedCache(state, payload: any[]) {
    state.modulesGroupedCache = {
      data: payload,
      lastFetchTime: Date.now(),
      isValid: true,
    };
  },

  /**
   * Invalidate grouped modules cache
   * Called after mutations (create/update/delete)
   */
  invalidateModulesGroupedCache(state) {
    state.modulesGroupedCache = {
      data: [],
      lastFetchTime: null,
      isValid: false,
    };
  },

  /**
   * Clear all grouped cache
   */
  clearModulesGroupedCache(state) {
    state.modulesGroupedCache = {
      data: [],
      lastFetchTime: null,
      isValid: false,
    };
  },
};
